import { DialogId } from '@feedyou/schema'

import { DialogHierarchyMap } from './buildDialogHierarchyMap'

export const isDialogEnabled = (id: DialogId, hierarchyMap: DialogHierarchyMap): boolean => {
  return !!(
    hierarchyMap.get(id)?.enabledConnectionsOnly.parents.size || // I <3 PRETTIER
    hierarchyMap.get(id)?.parentEntryPoints.size
  )
}
